import { z } from "zod";
import {
  phoneNumberSchema,
  phoneNumberOptionalSchema,
} from "../utils/validationUtils";

/**
 * A brand is an advertiser with exactly one portal login, so the brand and its
 * account are the same record — a `users` row carrying the "Brand" role.
 * Creating one generates a password and emails the credentials.
 */
export const brandCreateSchema = z.object({
  name: z.string().min(1, "Name is required"),
  email: z.string().email("Invalid email"),
  phoneNumber: phoneNumberSchema,
  username: z.string().optional(),
});

export const brandUpdateSchema = z.object({
  name: z.string().min(1, "Name is required").optional(),
  email: z.string().email("Invalid email").optional(),
  phoneNumber: phoneNumberOptionalSchema,
  isActive: z.boolean().optional(),
});

export type BrandCreateFormData = z.infer<typeof brandCreateSchema>;
export type BrandUpdateFormData = z.infer<typeof brandUpdateSchema>;

export interface Brand {
  id: string;
  name: string;
  username?: string;
  email: string;
  phoneNumber?: string;
  isActive: boolean;
  tenantId?: string;
  roleId?: string;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
  creativeCount: number;
}

export interface BrandResult {
  brands: Brand[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface BrandFilters {
  page?: number;
  pageSize?: number;
  search?: string;
}

export interface UpdateBrandPayload {
  id: string;
  brand: BrandUpdateFormData;
}

export interface AssignCreativesPayload {
  creativeIds: string[];
  /** null unassigns. */
  brandId: string | null;
}
